// extracted by mini-css-extract-plugin
module.exports = {"contentRowOne":"Feature_contentRowOne__3h78X","flexboxContentContainer":"Feature_flexboxContentContainer__3nJb9","itemBox":"Feature_itemBox__1fNBK"};